<template>
  <div>
    <form
      v-if="loaded"
      class=""
      action=""
      method="post"
      v-on:submit.prevent="handleSubmit()"
    >
      <div class="form__content">
        <div class="field-group">
          <hr>
        </div>
        <div class="field-group">
          <TextInput
            index="firstName"
            v-bind:field="data.firstName"
            v-bind:initial="firstName"
            v-model="firstName"
            validate="required"
            autocomplete="given-name"
          />
        </div>
        <div class="field-group">
          <TextInput
            index="lastName"
            v-bind:field="data.lastName"
            v-bind:initial="lastName"
            v-model="lastName"
            validate="required"
            autocomplete="family-name"
          />
        </div>
        <div class="field-group">
          <TextInput
            index="email"
            v-bind:field="data.email"
            v-bind:initial="email"
            v-model="email"
            validate="required|email"
            autocomplete="email"
          />
        </div>
        <div class="field-group">
          <MobileField
            index="mobile"
            v-bind:field="data.mobile"
            v-bind:initial="mobile"
            v-model="mobile"
            autocomplete="tel"
            name="mobile"
            v-bind:class="{
              'error--hide': hideMobileError,
            }"
            v-validate="{
              required: data.mobile.mandatory,
              regex: /^\+(6[1-4])[0-9]{7,}$/,
            }"
          />
        </div>
        <div class="field-group">
          <div class="field-set">
            <RadioCheckboxGroup
              v-bind:fieldArray="data.TandC.fields"
              v-bind:type="data.TandC.type"
              v-bind:inline="data.TandC.inline"
              v-bind:initial="tandc"
              v-model="tandc"
              validate="required"
              errorMsg="Please confirm Terms and Conditions."
            />
          </div>
        </div>
        <div class="field-group">
          <p class="field__text">* Required Fields</p>
        </div>
        <div
          class="field-group field-group--center"
          v-bind:class="{
            'is-danger--hide': hideSubmitError,
          }"
        >
          <div class="is-danger">
            <span v-html="submitErrorMsg"></span>
          </div>
        </div>
        <div class="field-group field-group--center">
          <ButtonField
            index="submit"
            v-bind:field="data.button"
          />
        </div>
      </div>
    </form>
    <Loading v-else/>
  </div>
</template>

<script>
// @ is an alias to /src
import form from '@/components/mixin/form';
import Loading from '@/components/Loading.vue';

// Data
import fieldData from '@/data/form-canberra-fields.json';

export default {
  name: 'ConfirmForm',
  mixins: [form],
  components: {
    Loading,
  },
  data() {
    return {
      data: fieldData.formFields,
      loaded: true,
      submitted: false,
      firstName: '',
      lastName: '',
      mobile: '',
      tandc: '',
      email: '',
      submitErrorMsg: 'Please fill in all mandatory fields.',
    };
  },
  methods: {
    handleSubmit() {
      this.validateForm(() => {
        this.loaded = false;

        const postUrl = 'https://nike.us5.list-manage.com/subscribe/post?u=285fce70c79eb27fab5f7f465&amp;id=3a7f075cf5';

        // const headers = {
        //   'Content-Type': 'application/json',
        // };

        const postData = {
          FNAME: this.firstName,
          LNAME: this.lastName,
          EMAIL: this.email,
          PHONE: this.mobile,
        };

        console.log('submit');

        this.$jsonp(postUrl, postData)
          .then((json) => {
            // Success.
            console.log(json);
            this.$router.push({
              path: '/thank-you-canberra',
            });
          }).catch((err) => {
            // Failed.
            console.log(err);
            this.$router.push({
              path: '/thank-you-canberra',
            });
          });

        setTimeout(() => {
          this.$router.push({
            path: '/thank-you-canberra',
          });
        }, 3000);
      });
    },
  },
};
</script>
